export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5038.b89dfb9e.jpg";